import React from 'react';
import PropTypes from 'prop-types';

import PopupSweet from '../common/PopupSweet';
import Subscription from '../../models/Subscription';
import i18n from '../../i18n';
import Utils from '../../utils/utils';

const MICExchangeAfterSubEndDatePopup = ({ show, subscription, closeModal, onFinalize }) => {
    const popupContent = `${i18n.t('messaging:mic.activate_autorenew_popup.content')}
        <span style="font-weight: bold; display: block;">
            ${i18n.t('messaging:mic.activate_autorenew_popup.content.finalization')}
        </span`;

    const subEndDate = subscription.get('end_on').format('DD/MM');

    const customStyle = {
        title: { fontSize: '25px', margin: '50px 90px 20px' },
        image: { marginBottom: '20px' },
        cta: { margin: '25px auto', padding: '15px 25%', borderRadius: '7px' },
        footer: { marginBottom: '50px' }
    };

    return (
        <PopupSweet
            show={show}
            className="activate-autorenew-finalize"
            title={i18n.t('messaging:mic.activate_autorenew_popup.title')}
            image={`${Utils.getAssetsDomain()}/images/website/messaging/mic-exchange-finalization.webp`}
            content={popupContent}
            approvedOrPayment={() => onFinalize(true)}
            textButton={i18n.t('messaging:mic.activate_autorenew_popup.cta_text.finalize')}
            closeModal={closeModal}
            underTextButton={i18n.t('messaging:mic.activate_autorenew_popup.footer_text', { subEndDate })}
            inlineCustomStyle={customStyle}
        />
    );
};

MICExchangeAfterSubEndDatePopup.propTypes = {
    show: PropTypes.bool,
    closeModal: PropTypes.func,
    subscription: PropTypes.instanceOf(Subscription),
    onFinalize: PropTypes.func.isRequired
};

export default MICExchangeAfterSubEndDatePopup;
